import { dataSyringe } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSyringe = /*#__PURE__*/createIcon(dataSyringe)
export default IconSyringe
